import AppLayout from "../components/layout/AppLayout";
import WarehouseMembersTableComponent from "../components/warehouseMember/WarehouseMembersTableComponent";

export default function WarehouseMembers() {
  return (
    <AppLayout>
      <WarehouseMembersTableComponent />
    </AppLayout>
  );
}
